import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { HttpService } from 'src/app/http/http.service';
import { ConstantUtil } from 'src/app/util/constant.util';

@Injectable({
  providedIn: 'root'
})
export class SystemConfigService {
  private readonly http = inject(HttpService);

  /**
   * 通过指定key获取系统配置数据
   * @param key 配置项的key
   * @returns Observable<any> 返回配置数据
   */
  getSystemData(key: string): Observable<any> {
    return this.http.post(`${ConstantUtil.TENANT_CONFIG_DATA_V1_SYS_AILE_DATA}/${key}`, {}).pipe(
      map(response => {
        if (response.success && response.data) {
          return response.data;
        }
        return null;
      })
    );
  }

  /**
   * 获取Facebook App ID
   * @returns Observable<string> 返回Facebook App ID
   */
  getFacebookAppId(): Observable<string> {
    return this.getSystemData('facebookAppId').pipe(
      map(data => {
        return data ?? '';
      })
    );
  }
  getInstagramAppId(): Observable<string> {
    return this.getSystemData('instagramAppId').pipe(
      map(data => {
        return data ?? '';
      })
    );
  }
}
